import { render, staticRenderFns } from "./SendRecode.vue?vue&type=template&id=789c2939&scoped=true"
import script from "./SendRecode.vue?vue&type=script&lang=js"
export * from "./SendRecode.vue?vue&type=script&lang=js"
import style0 from "./SendRecode.vue?vue&type=style&index=0&id=789c2939&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789c2939",
  null
  
)

export default component.exports